import { Component, OnInit, Input } from '@angular/core';

import { DialogService } from '@services/dialog/';

import { ITransferHistory, TransferStatus } from '@services/registrations/registrations.models';

import { ViewTransferDetailsComponent } from './../view-transfer-details/view-transfer-details.component';

@Component({
	selector: 'app-view-transfer-history',
	templateUrl: './view-transfer-history.component.html',
	styleUrls: ['./view-transfer-history.component.scss']
})
export class ViewTransferHistoryComponent implements OnInit {
	@Input() header: string;
	@Input() transferHistory: ITransferHistory[];

	constructor(
		private dialogService: DialogService
	) { }

	ngOnInit(): void {
		this.prepData();
	}

	prepData(): void {
		for (let i = 0; i < this.transferHistory.length; i++) {
			if (this.transferHistory[i]['accepted']) {
				this.transferHistory[i]['result'] = TransferStatus.accepted;
			} else if (this.transferHistory[i]['denied']) {
				this.transferHistory[i]['result'] = TransferStatus.denied;
			} else {
				this.transferHistory[i]['result'] = TransferStatus.open;
			}
		}
	}

	public viewTransferDetails(request: any): void {
		this.dialogService.open(ViewTransferDetailsComponent, {
			data: {
				request: request,
				callback: (requestId: string) => {
				}
			}
		});
	}
}
